export default {
  assignedToMe: 'Przypisane mi',
  selectInReviewState: 'Wybierz zadania do przeglądu',
};
